import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addZeroWidthSpace',
    standalone: false
})
export class AddZeroWidthSpacePipe implements PipeTransform {

  transform(text: string): string {
    return text.replace(/\//g, '/\u200b');
  }

}
